function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["items"],
  _excluded2 = ["icon"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import config from '../../../items/footer.json';
import { EEALocales, EuropeWithoutGBIELocales, AsiaLocales, PacificLocales, NorthAmLocales, SouthAmLocales, interpolateLinkForLocale, interpolateLinkForRegion, Locale } from '../../common/l10n';
import getIcon from '../../common/icons';
import Region from '../../common/l10n/Region';
export default function getItems(locale) {
  var newLocale = EEALocales.indexOf(locale) > -1 ? 'eea' : locale;
  var region = matchLocaleToNewsroomRegion(locale);
  return {
    top: config.top.map(function (section) {
      return createSectionWithItems(section, locale, region);
    }),
    bottom: config.bottom.map(function (item) {
      return createItem(item, locale);
    }),
    small: config.small.map(function (item) {
      return createItem(item, newLocale);
    }).filter(Boolean)
  };
}
export function getItemsLight(locale) {
  var newLocale = EEALocales.indexOf(locale) > -1 ? 'eea' : locale;
  return config.light.map(function (item) {
    return createItem(item, newLocale);
  }).filter(Boolean);
}
function createSectionWithItems(_ref, locale, region) {
  var items = _ref.items,
    section = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread(_objectSpread({}, section), {}, {
    items: items.map(function (item) {
      return createItem(item, locale, region);
    }).filter(Boolean)
  });
}
function createItem(item, locale, region) {
  if (!item) {
    return null;
  }
  if (!shouldShowItemByLocale(item, locale)) {
    return null;
  }
  if (item.icons) {
    return createItemWithIcons(item);
  }
  if (item.localized) {
    var localizedItem = localizeItem(item, locale);
    return createItem(localizedItem, locale);
  }
  return localizeLinkInItem(item, locale, region);
}
function localizeLinkInItem(item, locale, region) {
  var isLocaleAvailable = item.availableLocales ? item.availableLocales.includes(locale) : true;
  return item.link ? _objectSpread(_objectSpread({}, item), {}, {
    link: item.link.includes(':region') ? interpolateLinkForRegion(item.link, region) : interpolateLinkForLocale(item.link, isLocaleAvailable ? locale : Locale.GB)
  }) : item;
}
function localizeItem(_ref2, locale) {
  var options = _ref2.options;
  return options[locale.toLowerCase()] || options["default"];
}
function createItemWithIcons(item) {
  return _objectSpread(_objectSpread({}, item), {}, {
    icons: item.icons.map(function (_ref3) {
      var icon = _ref3.icon,
        otherProperties = _objectWithoutProperties(_ref3, _excluded2);
      return _objectSpread(_objectSpread({}, otherProperties), {}, {
        Icon: getIcon(icon)
      });
    })
  });
}
function shouldShowItemByLocale(item, locale) {
  if (item.hiddenLocale && item.hiddenLocale.indexOf(locale) !== -1) {
    return false;
  }
  if (item.showForLocale && !item.showForLocale.includes(locale)) {
    return false;
  }
  return true;
}
function matchLocaleToNewsroomRegion(locale) {
  if (EuropeWithoutGBIELocales.includes(locale)) {
    return Region.EuropeWithoutGBIE;
  }
  if (AsiaLocales.includes(locale)) {
    return Region.Asia;
  }
  if (PacificLocales.includes(locale)) {
    return Region.Pacific;
  }
  if (NorthAmLocales.includes(locale)) {
    return Region.NorthAm;
  }
  if (SouthAmLocales.includes(locale)) {
    return Region.SouthAm;
  }
  return Region.GBIE;
}